export default __webpack_public_path__ + "static/media/app_match_summary-challenge-match.5a4b4749.jpeg";